// extracted by mini-css-extract-plugin
module.exports = {"title":"Training2409_title_1QoHA","video":"Training2409_video_1Xn9s","note":"Training2409_note_rkwa6"};